// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsb1crf{width:9pt}
._1bsbdlk8{width:14px}
._1bsbf6fq{width:18px}
._1bsbo7ao{width:15px}
._1xi21v6z{right:7px}
._1xi2idpf{right:0}
._1xi2myb0{right:-4px}
._1xi2t94y{right:1px}
._4t3i1crf{height:9pt}
._4t3idlk8{height:14px}
._4t3if6fq{height:18px}
._4t3io7ao{height:15px}
._94n51v6z{bottom:7px}
._94n5idpf{bottom:0}
._94n5myb0{bottom:-4px}
._94n5t94y{bottom:1px}
._kqswstnw{position:absolute}
._lcxvglyw{pointer-events:none}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/avatar/dist/esm/presence.compiled.css"],"names":[],"mappings":"AAAA,WAAW,SAAS;AACpB,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,SAAS;AACpB,WAAW,OAAO;AAClB,WAAW,UAAU;AACrB,WAAW,SAAS;AACpB,WAAW,UAAU;AACrB,WAAW,WAAW;AACtB,WAAW,WAAW;AACtB,WAAW,WAAW;AACtB,WAAW,UAAU;AACrB,WAAW,QAAQ;AACnB,WAAW,WAAW;AACtB,WAAW,UAAU;AACrB,WAAW,iBAAiB;AAC5B,WAAW,mBAAmB","sourcesContent":["._1bsb1crf{width:9pt}\n._1bsbdlk8{width:14px}\n._1bsbf6fq{width:18px}\n._1bsbo7ao{width:15px}\n._1xi21v6z{right:7px}\n._1xi2idpf{right:0}\n._1xi2myb0{right:-4px}\n._1xi2t94y{right:1px}\n._4t3i1crf{height:9pt}\n._4t3idlk8{height:14px}\n._4t3if6fq{height:18px}\n._4t3io7ao{height:15px}\n._94n51v6z{bottom:7px}\n._94n5idpf{bottom:0}\n._94n5myb0{bottom:-4px}\n._94n5t94y{bottom:1px}\n._kqswstnw{position:absolute}\n._lcxvglyw{pointer-events:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
